@if (hasUnassignedPoints()) {
  <onyx-information-heading [identifierColor]="identifierColor()">
    {{ `${I18N}.unassignedPoints.heading` | translate }}
  </onyx-information-heading>

  <div class="group">
    <app-swap-modal-summary-item-unassigned-points-group
      [reason]="SwapUnassignPointReason.SEMI_TRAILER"
      [points]="points().unassignedTrailerPoints ?? []"
      translateKey="trailerReason"
      [identifierColor]="identifierColor()"
    ></app-swap-modal-summary-item-unassigned-points-group>

    <app-swap-modal-summary-item-unassigned-points-group
      [reason]="SwapUnassignPointReason.POINT"
      [points]="points().unassignedPoints ?? []"
      translateKey="pointReason"
      [identifierColor]="identifierColor()"
    ></app-swap-modal-summary-item-unassigned-points-group>
  </div>
} @else if (!isDouble()) {
  <onyx-information-heading>
    <span class="f-muted">
      {{ `${I18N}.unassignedPoints.missing` | translate }}
    </span>
  </onyx-information-heading>
}
